import React from 'react';
import c from 'classnames';

import { SearchForumCategoryPosts } from '../../../../components';

import './style.scss';

export interface ForumSearchCategoryPostsProps {
  tid: number; // Category taxonomy term ID
  uid?: number;
  className?: string;
}

const ForumSearchCategoryPosts: React.FC<ForumSearchCategoryPostsProps> = (props) => {
  const { tid, uid, className } = props;
  const classNames = c('ForumSearchCategoryPosts', className);

  return (
    <div className={classNames}>
      <SearchForumCategoryPosts tid={tid} uid={uid}>
        <SearchForumCategoryPosts.Stats className="mb-4" />
        <SearchForumCategoryPosts.Results uid={uid} className="mt-4" />
        <SearchForumCategoryPosts.Pagination className="mt-4" />
      </SearchForumCategoryPosts>
    </div>
  );
};

export default ForumSearchCategoryPosts;
